import { render } from "./inlet-outlet-icon.vue?vue&type=template&id=27ff22da"
const script = {}

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__